import { IAuthTokenStore, ITokens } from '../store';
import { BaseService } from './BaseService';

// TODO remove any types Promise<void> is not working with jsii
export interface IAuthService {
  register(email: string, password: string, optOut?: string, params?: Record<string, unknown>): Promise<any>;
  login(email: string, password: string, params?: Record<string, unknown>): Promise<any>;
  refresh(refreshToken: string): Promise<ITokens>;
}

/**
 */
export class AuthDispatcherService extends BaseService implements IAuthService {
  private _authStore: IAuthTokenStore | undefined;

  public constructor() {
    super({ configPath: 'auth' });
  }

  async authService(): Promise<IAuthService> {
    const { type } = await this.config() || {};
    // @ts-ignore
    return this.core.api[type || 'authRest'];
  }

  async register(email: string, password: string, optOut?: string, params?: Record<string, unknown>) {
    const service = await this.authService();
    return service.register(email, password, optOut, params);
  }

  async login(email: string, password: string, params?: Record<string, unknown>) {
    const service = await this.authService();
    return service.login(email, password, params);
  }

  async refresh(refreshToken: string): Promise<ITokens> {
    const service = await this.authService();
    return service.refresh(refreshToken);
  }

  set authStore(authStore) {
    this._authStore = authStore;
  }

  get authStore() {
    return this._authStore;
  }
}

export default AuthDispatcherService;
